$(document).on("turbolinks:load", function(){
    $('.eventpop > .icon-close').click(function () {
        console.log('aa')
        $('.eventpop').removeClass('active');
    })

    $('.eventpop > section> .btnGroup > button').click(function(){
        window.location.href = $(this).data('href');
    });
});